import Typography from 'typography'
import Wordpress2016 from 'typography-theme-wordpress-2016'

delete Wordpress2016.googleFonts

Wordpress2016.overrideThemeStyles = ({rhythm}) => ({
  'a.gatsby-resp-image-link': {
    boxShadow: 'none',
  },
  h1: {
    fontFamily: ['Lora', 'serif'].join(','),
    fontWeight: 'bold'
  },
  h2: {
    fontFamily: ['Lora', 'serif'].join(','),
  },
  h3: {
    fontWeight: 'bold'
  },
  a: {
    boxShadow: '0 1px 0 0 currentColor',
    color: '#1C2296',
    textDecoration: 'none',
  },
  'a:hover,a:active': {
    boxShadow: 'none',
  },
})

const marketingTheme = {
  ...Wordpress2016,
  headerWeight: 400,
  headerFontFamily: ['Karla', 'sans-serif'],
  bodyFontFamily: ['Karla', 'sans-serif'],
}

const typography = new Typography(marketingTheme)

// Hot reload typography in development.
if (process.env.NODE_ENV !== 'production') {
  typography.injectStyles()
}

const styleHTML = `
  body::-webkit-scrollbar-thumb {
    background-color: #1C2296;
    border-radius: 7px;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::selection {
    background: #FFFC78;
  }
`

if (typeof document !== "undefined") {
  // Replace existing
  if (document.getElementById("scrollbar-selection-styles")) {
    const styleNode = document.getElementById("scrollbar-selection-styles")
    styleNode.innerHTML = styleHTML
  } else {
    const node = document.createElement("style")
    node.id = "scrollbar-selection-styles"
    node.innerHTML = styleHTML
    document.head.appendChild(node)
  }
}

export default typography

export const rhythm = typography.rhythm
export const scale = typography.scale
